export default __webpack_public_path__ + "assets/7d10c756bf7dc76582bdb02de5742d9c.png";